import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckboxInput, Dialog, DialogActions, DialogContent } from '@guildeducationinc/recess';
import { TrackableButton, useLocale } from 'pe-core-frontend';
import { useState } from 'react';
import styles from './FieldSelectionModal.module.scss';
export const FieldSelectionModal = ({ fields, selectedFields, onChange, onClose, }) => {
    const { t } = useLocale();
    const [draft, setDraft] = useState(selectedFields);
    const handleSubmit = () => {
        const fieldCodes = fields.map(field => field.code);
        const sortedFields = draft.sort((a, b) => {
            return fieldCodes.indexOf(a) - fieldCodes.indexOf(b);
        });
        onChange(sortedFields);
        onClose();
    };
    const handleFieldChecked = (field, checked) => {
        if (checked) {
            setDraft([...draft, field.code]);
        }
        else {
            setDraft(draft.filter(code => code !== field.code));
        }
    };
    return (_jsxs(Dialog, { isOpen: true, title: t('Customize Fields'), onClose: onClose, fullScreen: true, children: [_jsx(DialogContent, { className: styles.content, children: fields.map(field => (_jsx("div", { children: _jsx(CheckboxInput, { label: field.name, type: 'checkbox', checked: draft.includes(field.code), onChange: e => handleFieldChecked(field, e.target.checked) }) }, field.id))) }), _jsxs(DialogActions, { fullScreen: true, children: [_jsx(TrackableButton, { enText: 'Cancel', tag: 'field_selection_modal', appearance: 'outline', onClick: onClose, children: t('Cancel') }), _jsx(TrackableButton, { enText: 'Submit', tag: 'field_selection_modal', onClick: handleSubmit, children: t('Submit') })] })] }));
};
